/**
 * Beyond enrollment enum status based on Docebo course status
 * from Enrollment
 */
export enum EnrollmentStatus {
  COMPLETED = 'completed',
  IN_PROGRESS = 'in_progress',
  ENROLLED = 'enrolled',
  WAITING = 'waiting',
}
